import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    standalone: true
})
export class JoinPipe implements PipeTransform {

    transform(values: Array<number> | [string], seperator: string): any {
        return values.join(seperator);
    }

}
